<template>
  <div id="content" class="myAccount">

    <div class="container">
      <div class="myAccountContent">
        <div class="row projectList">
            <h1 class="text-center">All current projects</h1>
            <div class="row project mt50" v-for="(project, p) in myProjectsFiltered" :key="p">
              <router-link :to="'/admin/project/'+project._id.$oid" class="projectName" v-if="project._id">{{project.name}}</router-link>
              <span v-if='project.customer'>for {{project.customer.firstname}} {{project.customer.lastname}}</span>
              <span>Associated expert : <span v-if="project.expert">{{project.expert.firstname}} {{project.expert.lastname}}</span><span v-else>NONE</span></span>
              <div class="" v-for="(sf, s) in project.search_field" :key="s">
                    <div class="action_list done">
                      <div class="name">
                        <router-link :to="'/admin/project/'+project._id.$oid+'#'+sf._id.$oid">
                          <span>{{sf.name}}</span>
                                  <img :src="require('@/assets/action_go_to.svg')" alt="">
                                </router-link>
                      </div>

                    </div>


                  </div>
        </div>
      </div>
    </div>
  </div>  </div>
</template>
<script>
 // import AddCommentModal from '@/components/modals/addComment.vue'
 // import NewValueModal from '@/components/modals/addValue.vue'
   // import AddSomeThingLink from '@/components/AddSomeThingLink.vue'
// import BookACall from '@/components/bookacall.vue'
// import { toast } from 'vue-sonner'
import api from '@/tools/api';
//import StartupInfoLine from '@/components/InfoStartupLine.vue'
import _ from 'lodash';

export default {
  components: {
    //StartupInfoLine,
    // AddSomeThingLink
    // Toaster,
    // BookACall
  },
  data() {
    return {
      seeAllStep: true,
      pageInfo: {
        mainTitle : "My dashboard space",
        subTitle : "Monitor progress and manage next steps",
      },
      search: {
        name: "",
        customer:"",
        searchfield : "",
      },
      userInfo: {},
      myProjects: [],
      myProjectsFiltered: [],
      experts_list: [
        {
          _id:1,
          name: "Expert 1",
        },
        {
          _id:2,
          name: "Expert 2",
        }
      ]
    }
  },
  methods:{
    gobackrouter : function(){
      this.$router.go(-1);
    },
  },
  mounted(){
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo);

   api.get(process.env.VUE_APP_API_URL+"/restrict/admin_projects_list").then( (r) => {
     // this.myProjects = r.data;
     this.myProjects = _.orderBy(r.data, 'name','asc');
     this.myProjectsFiltered = this.myProjects;
     console.log(r);
   }).catch( (e) => console.log(e));
 },
 watch: {
   search: {
     handler(val){
       console.log(val);
       console.log(this.search);
       var temp = this.myProjects;
       let search = this.search;
       console.log(search);
       if(search.name){
         temp = temp.filter(function(item){
           console.log(item.name);
           if(item.name.toUpperCase().includes(search.name.toUpperCase()))return item;
         })
       }
       if(search.customer){
         temp = temp.filter(function(item){
           var fullname = item.customer.firstname+" "+item.customer.lastname;
           if(fullname.toUpperCase().includes(search.customer.toUpperCase()))return item;
         })
       }
       if(search.searchfield){
         temp = temp.filter(function(item){
           if(item.search_field.filter(e => e.name.toUpperCase().includes(search.searchfield.toUpperCase())).length > 0)return item
         })
       }
       this.myProjectsFiltered = temp;
       // do stuff
     },
     deep: true
  }
 }
 // watch(search, (newValue, oldValue) => {
 //   console.log(oldValue);
 //   console.log(newValue);
 //   // fires on nested property mutations
 //   // Note: `newValue` will be equal to `oldValue` here
 //   // because they both point to the same object!
 // },{deep: true})
}
</script>
<style scoped >
.myAccount{
  padding-top:50px;
  padding-bottom: 50px;
}
.myAccountContent{
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
padding: 50px;
margin-top:50px;
margin-bottom: 50px;

}
.title{
  font-size: 24px;
  line-height:29px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
text-align:center;
}
.mt50{
  margin-top:50px;
}


.prev_step_btn{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
    margin:5px;
    display:inline-block;
    margin:auto;
    width:auto;
}

.myAccountContent{
  position:relative;
  padding-top:80px;
}
.mt20{
  margin-top:20px;
}
.mb20{
  margin-bottom: 20px;
}

.disconnect{
  position: absolute;
top: 10px;
right: 10px;
padding: 5px 20px;
color: #3783C5;
border: none;
border-bottom: 1px solid #3783C5;
border-radius: 0;
font-size: 16px;
font-weight: bold;
text-decoration: none;
}

.projectName{
  font-size : 28px;
  line-height: 34px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
text-decoration: none;
}

.project{
  margin-top: 50px;
  margin-bottom: 50px;
}


.projectList .project_searchfields{
  display:flex;
  flex-wrap: wrap;
  width: 100%;

  padding-top:20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #CCC;
}

@media screen and (max-width: 990px){
  .projectList .project_searchfields{
    flex-direction: column;
    gap: 20px;
}
}
.projectList .project_searchfields div{
  flex: 1;
}
.projectList .project_searchfields .searchfield_name{
  font-size:14px;
  line-height: 22px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
}
.projectList .project_searchfields .searchfield_name a{
text-decoration: none;
font-size:14px;
line-height: 22px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
}
.projectList .project_searchfields .searchfield_deliverable,
.projectList .project_searchfields .searchfield_action_required{
  font-size :13px;
  line-height:16px ;
letter-spacing: 0px;
color: #575757;
text-transform: uppercase;
}

.action_list a{
  text-decoration: none;
  color:inherit;
}
.action_list{
  border:0 !important;
}

.action_title{
  font-weight: 700;
  text-transform: uppercase;
  text-decoration: underline;
}



   .switch {
  --circle-dim: 1.4em;
  font-size: 17px;
  position: relative;
  display: inline-block;
  width: 3.5em;
  height: 2em;
  margin-left: 10px;
  margin-right: 10px;

}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.pre_text,
.after_text{

font-size: 12px;
line-height:22px ;
letter-spacing: 0px;
color: #3783C5;
opacity: 1;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  transition: .4s;
  border-radius: 30px;
  border: 1px solid #3783C5;
}

.slider-card {
  position: absolute;
  content: "";
  height: var(--circle-dim);
  width: var(--circle-dim);
  left: 0.3em;
  bottom: 0.3em;
  transition: .4s;
  pointer-events: none;
}

.slider-card-face {
  position: absolute;
  inset: 0;
  backface-visibility: hidden;
  perspective: 1000px;
  border-radius: 50%;
  transition: .4s transform;
}

.slider-card-front {
  background-color: #3783C5;
}

.slider-card-back {
  background-color: #FFF;
  transform: rotateY(180deg);
}

.current_all_toggle{
  text-align: center;
}

 .switch input:checked ~ .slider-card {
  transform: translateX(1.5em);
}

 .switch input:checked ~ .slider {
  background-color: #fff;
}

.search{
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;
}
/* .search_item{
  display:flex;
  flex-direction: column;
} */
.search_item input{
  border-bottom: 1px solid #3783C5;
  display:block;
}

.search_item{
  border:1px solid #3784C5;
  padding: 20px;
  position:relative;
  margin-top:25px;
}
.search_item span{
  position:absolute;
  top:-20px;
  padding:5px;
  left:20px;
  background:#FFF;
}

.cleanInput{
  position: absolute;
  right: 20px;
  top: 15px;
  height: 30px;
  width: 30px;
  border: none;
}


 .action_list{
   display: flex;
   gap: 20px;
   margin-top:25px;
   font-size:15px;
   line-height:20px;
   text-transform: uppercase;
   background:#3783C51A;
   border-radius:200px;
   padding-left:25px;
   padding-right:25px;
   padding-top:15px;
   padding-bottom: 14px;
   justify-content: space-between;
   color:#3783C5;
   font-weight: 500;
   opacity: .5;
 }
 .action_list.done{
   opacity:1;
 }

 .action_list .name{
   width:100%;
 }
 .action_list .name a{
   display: flex;
   justify-content: space-between;
   width: 100%;
 }
 .action_list .name a img{
      transition: transform 330ms ease-in-out;
 }
 .action_list .name a:hover img{
 transform:translateX(5px);
 }


</style>
